<template>
     <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify="validate"/>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  props: ['onSuccess'],
  data: () => ({
    sitekey: process.env.VUE_APP_RECAPTCHA,
    // sitekey: '6LcoaWwdAAAAAEwWscRz-b7_l53pMCYEcx--0yK_',
    vueWidgtId: 0
  }),
  components: {
    VueRecaptcha
  },
  mounted () {},
  methods: {
    validate (response) {
      this.onSuccess(response)
    }
  }
}
</script>

<style>

</style>
